import React, { Component } from "react";
import { Breadcrumb, PageHeader, Jumbotron, Grid, Row, Col, Image } from "react-bootstrap";
import './About.css';

export default class About extends Component {
  constructor(props) {
	super(props);
	this.state = {
	  isLoading: true
	};
  }
  render() {
    return (
      <div className="About">
      <Grid>
	    <Breadcrumb>
	      <Breadcrumb.Item href="/">Inicio</Breadcrumb.Item>
          <Breadcrumb.Item active>Quiénes somos</Breadcrumb.Item>
	    </Breadcrumb>
	    <PageHeader>
	      Quiénes somos
	    </PageHeader>
	    <Jumbotron>
        <Row>
          <Col md={4}>
            <Image src="/images/about.jpg" responsive rounded />
          </Col>
          <Col md={8}>
            <p>
    	      	Somos una Empresa con experiencia en manejo de gastos comunes y con una fuerte experiencia bancaria,
    	      	lo que permite ordenar de manera eficiente los gastos de una comunidad y cuidar los intereses de ella.
    	      </p>
          </Col>
        </Row>
    	</Jumbotron>
	    <PageHeader>
	      Misión
	    </PageHeader>
    	<Jumbotron>
        <Row>
          <Col md={4}>
            <Image src="/images/mission.jpg" responsive rounded />
          </Col>
          <Col md={8}>
            <p>
      		    Ser l&iacute;deres en el mercado de Administraci&oacute;n de comunidades a nivel nacional,
      		    con el principal objetivo de mantener informados a todos los residentes de cualquier novedad.
      		    Todo esto se consigue con la entrega de un servicio de excelencia, para satisfacer plenamente
      		    a nuestros clientes y mantener un alto prestigio en el mercado.
      		  </p>
          </Col>
        </Row>
	    </Jumbotron>
	    <PageHeader>
	      Nuestro equipo
	    </PageHeader>
    	<Jumbotron>
        <Row>
          <Col md={4}>
            <Image src="/images/team.jpg" responsive rounded />
          </Col>
          <Col md={8}>
            <p>
      		  	Nuestra Empresa naci&oacute; en a&ntilde;o 2008 por un grupo de personas que dada su experiencia
      			en vivir en comunidades y recopilando las mejores pr&aacute;cticas, cre&oacute; PORTAL CONDOMINIO,
      			con la &uacute;nica intenci&oacute;n de hacer trasparente y mas econ&oacute;mica la
      			administraci&oacute;n de Gastos Comunes.
      		  </p>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
      		  <p>
      		    El equipo naci&oacute; de las siguientes personas que aportaron con su experiencia: Mayordomo,
      			Corredora de propiedades, Administrador de Edificios, Presidente de Comit&eacute;, Integrantes de Comit&eacute;,
      			Residentes de Comunidades, Dise&ntilde;adores de Sitios Web, Personal de desarrollo de Software y
      			Apoyo Gerencial de Ingenier&iacute;a y Marketing.
      		  </p>
          </Col>
        </Row>
	    </Jumbotron>
      </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/About.js